import appConfig from './appConfig';

export function assetUrl() {
  return appConfig.getMyConfig().assetUrl + 'assets/';
}

export function animationsUrl() {
  return assetUrl() + 'animations/';
}
